import apinode from '../../apinode'

class MarcasService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`estoque/marca/${this.idconta}`)

    return response.data
  }
}

export default new MarcasService()
